import { render, staticRenderFns } from "./SubRatingList.vue?vue&type=template&id=26a55788"
import script from "./SubRatingList.vue?vue&type=script&lang=js"
export * from "./SubRatingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports